export enum LiveMapTabFilter {
  HISTORY = 'history',
  IN_PROGRESS = 'in_progress',
  GEOFENCE_REPORTS = 'geofence_reports',
}

export enum AssetLocationType {
  TRUCK = 'truck',
}
